import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Like, Repository } from 'typeorm';
import { BloodGroupEntity } from './blood-group.entity';
import { AllBGroupResponseModel, BGroupResponseModel } from './blood-response-module';
import { BloodGroupDTO, DeleteBloodGroupDTO, GroupSearchDto } from './dto/blood-group.dto';


@Injectable()
export class BloodGroupService {
    constructor (
        @InjectRepository(BloodGroupEntity)
        private BGroupRepo: Repository<BloodGroupEntity>, 
    ) {}    
    
    
    async createBloodGroup(queryParams,bgDto:BloodGroupDTO,request:Request): Promise<BGroupResponseModel> {
        const response = new BGroupResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saved = await this.BGroupRepo.save(bgDto);
                const data = await this.BGroupRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Blood Group saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Blood Group not saved')
                }
            } else {
                const saved = await this.BGroupRepo.save(bgDto);
                const data = await this.BGroupRepo.findOne({
                    where:{Id:saved.Id}
                })
                if(saved) {
                    response.status = true;
                    response.data   = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Blood Group saved successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Blood Group not saved')
                }
            }      
            return response;
        } catch (error) {
            throw error;
        }
    }

    async updateBloodGroup(queryParams, bgDto:BloodGroupDTO,request:Request): Promise<BGroupResponseModel> {
        const response = new BGroupResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const updatedData = await this.BGroupRepo.update(bgDto.Id,bgDto);
                const data = await this.BGroupRepo.findOne({
                    where: {Id:bgDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Blood Group record update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Blood Group record updated';
                response.intlCode = 11108;
                response.data = data;
            } else  {
                const updatedData = await this.BGroupRepo.update(bgDto.Id,bgDto);
                const data = await this.BGroupRepo.findOne({
                    where: {Id:bgDto.Id},
                });
                if(!updatedData) {
                    throw new ErrorResponse(99908,'Blood Group record update failed')
                }                 
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Blood Group record updated';
                response.intlCode = 11108;
                response.data = data;
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
	
    async getBloodGroups(queryParams,request:Request):Promise<AllBGroupResponseModel> {
        const response = new AllBGroupResponseModel();
        try {
            const finalData: any[] = [];
            if(queryParams.apiVersion == 1) {
                const data = await this.BGroupRepo.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Name:b.name,
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }  else {
                const data = await this.BGroupRepo.find({
                    where: {status: true},
                    order: { createdAt: 'DESC' }
                });
                if(!data) {
                    throw new ErrorResponse(99908,'Data not found')
                }
                const final = data.map(b => {
                    return {
                        Id: b.Id,
                        Name:b.name,
                    }   
                });   
                response.status = true;
                response.data = final;
                response.statusCode = 50000;
                response.internalMessage = 'Data retrieved successfully';
                response.intlCode = 11108;              
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async deleteBloodGroup(queryParams,delDto:DeleteBloodGroupDTO, request:Request):Promise<BGroupResponseModel> {
        const response = new BGroupResponseModel();
        try {
            const updateRole = await this.BGroupRepo.update(delDto.Id, delDto);
            if(updateRole) {
                response.status = true;
                response.statusCode = 50000;
                response.internalMessage = 'Blood Group deleted successfully';
                response.intlCode = 11108;
            } else {
                throw new ErrorResponse(99998, 'Blood Group delete failed')
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async searchBloodGroup(queryParams,search,request:Request):Promise<AllBGroupResponseModel> {
        const response = new AllBGroupResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const data =await this.BGroupRepo.find({               
                    where: {name: Like(`%${search}%`),status: true},
                    order: { createdAt: 'DESC' }
                });
                let finalData : any[] = [];
                if(data) {
                    const final = data.map((p) => {
                        finalData.push({
                            Id:p.Id,
                            Name:p.name
                        })
                    })
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const data =await this.BGroupRepo.find({               
                    where: {name: Like(`%${search}%`),status: true},
                    order: { createdAt: 'DESC' }
                });
                let finalData : any[] = [];
                if(data) {
                    const final = data.map((p) => {
                        finalData.push({
                            Id:p.Id,
                            Name:p.name
                        })
                    })
                    response.status = true;
                    response.data = finalData;
                    response.statusCode = 50000;
                    response.internalMessage = 'data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }    
    }

}
